import { useQuery } from "@tanstack/react-query"
import { fetchBrandColors, fetchBrandFonts } from "sdk/brand"

export const brandKeys = {
  all: ["brand"],
  colors: () => [...brandKeys.all, "colors"],
  fonts: type => [...brandKeys.all, "fonts", type]
}

export function useBrandColors() {
  return useQuery({
    queryKey: brandKeys.colors(),
    queryFn: fetchBrandColors,
    initialData: () => window.app?.user?.colors || [],
    staleTime: Infinity
  })
}

export function useBrandFonts(type, options = {}) {
  const query = useQuery({
    queryKey: brandKeys.fonts(type),
    queryFn: () => fetchBrandFonts(type),
    staleTime: Infinity,
    ...options
  })

  return { ...query, data: query.data || [] }
}
